var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Dkxc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#E9EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25 38H-0.75V51H50.25V38Z",
    fill: "url(#paint0_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3035 33.1431L30.5473 34.0052L31.7662 34.1284L33.9603 33.8821L30.7911 33.7589L30.6692 33.02H34.0822L34.6917 32.7737L35.423 32.5274L37.4952 32.6505V33.5126H37.0076L35.1792 33.6357L35.0574 34.1284L37.4952 33.7589V34.3747L37.2514 34.621L34.4479 35.1136L30.1816 34.7441H28.2314L27.5 34.3747V33.7589L27.6219 33.8821L29.2065 34.0052L29.9379 34.1284L29.816 33.6357H29.3284L28.7189 33.5126L27.9876 33.3894L27.5 33.1431V32.7544L27.7438 32.2811L27.8657 32.6505L28.3532 32.7737L29.5722 32.8968L30.3035 33.1431Z",
    fill: "#E9EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2683 29.9138L29.4504 31.6653H35.7889L34.7665 29.9138L32.5174 29.6949L30.2683 29.9138Z",
    fill: "#E9EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4503 31.6653H28.4751C28.3406 31.6653 28.2314 31.5549 28.2314 31.419C28.2314 31.283 28.3406 31.1727 28.4751 31.1727H29.4503C29.5849 31.1727 29.6941 31.283 29.6941 31.419C29.6941 31.5549 29.5849 31.6653 29.4503 31.6653Z",
    fill: "url(#paint1_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8243 32.1578C35.7361 32.1578 35.6542 32.0963 35.626 32.0002C35.5607 31.7757 34.8392 30.2477 34.6666 30.0852C34.5053 30.0048 33.2099 29.9001 32.4976 29.9001C31.7853 29.9001 30.4899 30.0048 30.314 30.096C30.1556 30.2477 29.4345 31.7757 29.3693 32.0002C29.3347 32.1189 29.2187 32.1848 29.1081 32.1474C28.9987 32.1094 28.9376 31.9826 28.9725 31.8638C29.0121 31.7288 29.8055 29.9028 30.1024 29.7072C30.4113 29.5032 32.2597 29.4485 32.4976 29.4485C32.7355 29.4485 34.5839 29.5032 34.8928 29.7072C35.1897 29.9032 35.9832 31.7288 36.0227 31.8638C36.0576 31.9826 35.9965 32.1094 35.8875 32.1474C35.8663 32.1546 35.8451 32.1578 35.8243 32.1578Z",
    fill: "url(#paint2_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4747 35.483C29.372 35.483 29.2895 35.5436 29.2658 35.6238L27.9388 35.3445V35.2983C27.9388 35.1963 27.8405 35.1135 27.7194 35.1135C27.5983 35.1135 27.5 35.1963 27.5 35.2983V36.0372C27.5 36.3427 27.7953 36.5914 28.1582 36.5914H29.0358C29.3987 36.5914 29.6941 36.3427 29.6941 36.0372V35.6677C29.6941 35.5658 29.5958 35.483 29.4747 35.483Z",
    fill: "url(#paint3_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2758 35.1135C37.1547 35.1135 37.0564 35.1963 37.0564 35.2983V35.3445L35.7294 35.6238C35.7057 35.5436 35.6232 35.483 35.5205 35.483C35.3994 35.483 35.3011 35.5658 35.3011 35.6677V36.0372C35.3011 36.3427 35.5965 36.5914 35.9594 36.5914H36.837C37.1999 36.5914 37.4952 36.3427 37.4952 36.0372V35.2983C37.4952 35.1963 37.3969 35.1135 37.2758 35.1135Z",
    fill: "url(#paint4_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5201 31.6653H35.5449C35.4104 31.6653 35.3011 31.5549 35.3011 31.419C35.3011 31.283 35.4104 31.1727 35.5449 31.1727H36.5201C36.6546 31.1727 36.7639 31.283 36.7639 31.419C36.7639 31.5549 36.6546 31.6653 36.5201 31.6653Z",
    fill: "url(#paint5_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4952 33.9376C37.4948 33.6299 37.5062 33.3672 37.4952 33.1431L36.9255 33.2698C36.8572 33.2819 35.4926 33.5065 35.1468 33.5065C35.0972 33.5515 35.0525 33.8494 35.0578 34.1283C36.2964 34.0615 37.2607 33.9729 37.2762 33.9715L37.4952 33.9376Z",
    fill: "url(#paint6_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9162 32.8679C27.9229 32.8679 29.2971 33.0727 29.7609 33.0727C29.9201 33.0727 30.0604 33.1335 30.1666 33.2484C30.3898 33.4903 30.4004 33.9142 30.3949 34.0793C31.0727 34.1076 31.8044 34.1283 32.4991 34.1283C33.1946 34.1283 33.9267 34.1076 34.6054 34.0793C34.6007 33.8927 34.6113 33.4253 34.8198 33.2045C34.9015 33.1183 35.0047 33.0727 35.1193 33.0727C35.3919 33.0727 36.4918 32.922 36.8924 32.8637L37.4952 32.7736C37.4952 32.281 37.3541 32.2836 37.1923 32.2363C37.098 32.2088 37.0487 32.14 36.9552 31.9998L36.8831 31.8943C36.7572 31.7182 36.5137 31.7106 36.2782 31.7038C36.2074 31.7017 36.0954 31.6983 36.0423 31.6861C36.0242 31.6595 35.9997 31.6371 35.9703 31.6211C35.5772 31.4045 34.0881 31.1727 32.4991 31.1727C30.9101 31.1727 29.4209 31.4045 29.0279 31.6211C28.9984 31.6371 28.974 31.6595 28.9554 31.6865C28.9024 31.6988 28.7903 31.7021 28.7195 31.7042C28.4845 31.711 28.241 31.7182 28.115 31.8943L28.043 32.0003C27.9495 32.1404 27.9002 32.2093 27.8058 32.2367C27.6407 32.2853 27.5501 32.455 27.5 32.7637L27.9162 32.8679ZM31.0247 33.2838H33.9735C34.0898 33.2838 34.1841 33.3784 34.1841 33.495C34.1841 33.6115 34.0898 33.7061 33.9735 33.7061H31.0247C30.9084 33.7061 30.814 33.6115 30.814 33.495C30.814 33.3784 30.9084 33.2838 31.0247 33.2838Z",
    fill: "url(#paint7_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3249 34.3975C37.2886 34.4004 34.7063 34.6067 32.4976 34.6067C30.2889 34.6067 27.7066 34.4004 27.6811 34.3987L27.5 34.38C27.5225 34.8306 27.5922 35.5061 27.8084 35.6208C28.0338 35.7399 30.6411 35.8525 32.4976 35.8525C34.3541 35.8525 36.9614 35.7399 37.1864 35.6203C37.4034 35.5053 37.4731 34.8252 37.4952 34.3746L37.3249 34.3975Z",
    fill: "url(#paint8_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9374 34.1283C29.9414 33.9563 29.9219 33.6564 29.8257 33.5344C29.8005 33.5025 29.7737 33.4896 29.7331 33.4896C29.254 33.4896 27.932 33.2584 27.876 33.2489L27.5142 33.1431C27.5041 33.369 27.5004 33.6336 27.5 33.94L27.7237 33.9672C27.7367 33.9686 28.6998 34.0592 29.9374 34.1283Z",
    fill: "url(#paint9_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9 13.8235H15.1125C12.625 13.8235 11.375 15.086 11.375 17.5985V37.5736H18.125V32.8861C18.125 32.3736 18.55 31.9486 19.0625 31.9486C19.575 31.9486 20 32.3611 20 32.8861V37.5736H26.625V17.5985C26.625 15.086 25.3875 13.8235 22.9 13.8235ZM22.1875 26.011H16C15.4875 26.011 15.0625 25.5861 15.0625 25.0735C15.0625 24.561 15.4875 24.136 16 24.136H22.1875C22.7 24.136 23.125 24.561 23.125 25.0735C23.125 25.5861 22.7 26.011 22.1875 26.011ZM22.1875 21.3235H16C15.4875 21.3235 15.0625 20.8985 15.0625 20.386C15.0625 19.8735 15.4875 19.4485 16 19.4485H22.1875C22.7 19.4485 23.125 19.8735 23.125 20.386C23.125 20.8985 22.7 21.3235 22.1875 21.3235Z",
    fill: "url(#paint10_linear_51_899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6625 36.636H37.5C38.0125 36.636 38.4375 37.061 38.4375 37.5735C38.4375 38.086 38.0125 38.511 37.5 38.511H33.7875C33.7625 38.511 33.75 38.5236 33.725 38.5236C33.7 38.5236 33.6875 38.511 33.6625 38.511H10C9.4875 38.511 9.0625 38.086 9.0625 37.5735C9.0625 37.061 9.4875 36.636 10 36.636H32.775H34.6625Z",
    fill: "url(#paint11_linear_51_899)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_899",
    x1: 24.75,
    y1: 38,
    x2: 24.75,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_899",
    x1: 32.5,
    y1: 29.4485,
    x2: 32.5,
    y2: 36.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_899",
    x1: 32.5,
    y1: 29.4485,
    x2: 32.5,
    y2: 36.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_899",
    x1: 32.5,
    y1: 29.4485,
    x2: 32.5,
    y2: 36.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_899",
    x1: 32.5,
    y1: 29.4485,
    x2: 32.5,
    y2: 36.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_899",
    x1: 32.5,
    y1: 29.4485,
    x2: 32.5,
    y2: 36.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_899",
    x1: 32.5,
    y1: 29.4485,
    x2: 32.5,
    y2: 36.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_899",
    x1: 32.5,
    y1: 29.4485,
    x2: 32.5,
    y2: 36.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_899",
    x1: 32.5,
    y1: 29.4485,
    x2: 32.5,
    y2: 36.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_51_899",
    x1: 32.5,
    y1: 29.4485,
    x2: 32.5,
    y2: 36.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_51_899",
    x1: 11.375,
    y1: 23.9173,
    x2: 26.625,
    y2: 23.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_51_899",
    x1: 9.0625,
    y1: 37.4382,
    x2: 38.4375,
    y2: 37.4382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_899"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Dkxc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2dkxc.16caa8d4.svg";
export { ForwardRef as ReactComponent };